/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';

export const EmailTypeSchema = z.enum(["DEFAULT", "PERSONAL_WORK", "PERSONAL_HOME", "BUSINESS_GENERAL", "BUSINESS_SUPPORT", "BUSINESS_SALES", "BUSINESS_LEGAL", "BUSINESS_OTHER"])
